import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="overview-list"
export default class extends Controller {
  static outlets = ["selected-row"]
  static targets = ["selectAll"]
  static values = { url: String, params: String, single: Boolean }

  toggleBulk(event) {
    // On pages without bulk actions only one row may be selected at a time.
    if (this.singleValue && event?.target?.checked) {
      this.selectedRowOutlets.forEach((row) => {
        if (row.checkboxTarget !== event.target) row.checkboxTarget.checked = false
      })
    }

    // Refresh every row's highlight (needed when selection moves between rows).
    this.selectedRowOutlets.forEach((row) => row.toggle())

    let [overview_counter, checked_element] = this.overviewCounter()
    this.showActionMenu(overview_counter, checked_element)
    this.toggleSelectAllCheckbox()
  }

  selectAll() {
    let checkboxes = this.selectedRowOutlets.map((row) => row.checkboxTarget)

    if (this.selectAllTarget.checked) {
      Array.from(checkboxes).forEach(function (element) {
        element.checked = true
      })
    } else {
      Array.from(checkboxes).forEach(function (element) {
        element.checked = false
      })
    }

    this.selectedRowOutlets.forEach((row) => row.toggle())

    this.toggleBulk()
  }

  overviewCounter() {
    let checkboxes = this.selectedRowOutlets.map((row) => row.checkboxTarget)
    let overview_counter = 0
    let checked_element_value = []

    Array.from(checkboxes).forEach(function (element) {
      if (element.checked) {
        overview_counter += 1
        checked_element_value.push(element.value)
      }
    })

    return [overview_counter, checked_element_value]
  }

  showActionMenu(elements_count, checked_element_value) {
    let path = this.urlValue
    let params = new URLSearchParams(this.paramsValue)

    if (elements_count == 1) {
      params.append("id", checked_element_value)
      get(`/action_menu/single/${path}?${params}`, {
        responseKind: "turbo-stream",
      })
    } else if (elements_count > 1) {
      params.append("ids", checked_element_value)
      get(`/action_menu/multiple/${path}?${params}`, {
        responseKind: "turbo-stream",
      })
    } else if (elements_count == 0) {
      get(`/action_menu/default/${path}?${params}`, {
        responseKind: "turbo-stream",
      })
    }
  }

  toggleSelectAllCheckbox() {
    let allCheckboxes = this.selectedRowOutlets.map((row) => row.checkboxTarget)
    let checkedCheckboxesSize = allCheckboxes.filter(
      (checkbox) => checkbox.checked,
    ).length
    let selectAllCheckbox = document.getElementById("select-all")
    if (!selectAllCheckbox) return

    if (allCheckboxes.length === checkedCheckboxesSize) {
      selectAllCheckbox.checked = true
    } else {
      selectAllCheckbox.checked = false
    }
  }
}
